











import { Component, Vue } from 'vue-property-decorator'
import MainPage from './components/MainPage.vue'
import IntroBox from './components/IntroBox.vue'
import Game from './classes/game'

const SAVE_TIME = 60 * 1000

const SAVE_KEY = 'sudokuSave'

@Component({
  components: {
    IntroBox,
    MainPage
  }
})
export default class App extends Vue {
  private showIntro: boolean;
  private saveInterval: number;
  private settings: Record<string, boolean>;
  private game: Game;

  constructor () {
    super()

    const saveString = window.localStorage.getItem(SAVE_KEY)

    this.showIntro = true

    const save = saveString ? JSON.parse(saveString) : {}

    this.settings = save.settings || {
      autoSave: true
    }

    this.game = new Game(save.game || {})

    this.saveInterval = setInterval(() => this.save(), SAVE_TIME)
  }

  close () {
    this.showIntro = false
  }

  reset () {
    window.localStorage.clear()
    window.location.reload()
  }

  save () {
    if (this.settings.autoSave) {
      const save = JSON.stringify({
        settings: this.settings,
        game: this.game.serialize()
      })
      window.localStorage.setItem(SAVE_KEY, save)
    }
  }
}
